import coverIllus from "../assets/illustrations/guide/emotional-awareness/cover.svg";
import introductionIllus from "../assets/illustrations/guide/emotional-awareness/introduction.svg";
import explainedIllus from "../assets/illustrations/guide/emotional-awareness/explained.svg";
import patternsIllus from "../assets/illustrations/guide/emotional-awareness/patterns.svg";
import namingIllus from "../assets/illustrations/guide/emotional-awareness/naming.svg";
import triggersIllus from "../assets/illustrations/guide/emotional-awareness/triggers.svg";
import regulationIllus from "../assets/illustrations/guide/emotional-awareness/regulation.svg";
import shameIllus from "../assets/illustrations/guide/emotional-awareness/shame.svg";
import angerIllus from "../assets/illustrations/guide/emotional-awareness/anger.svg";
import resilienceIllus from "../assets/illustrations/guide/emotional-awareness/resilience.svg";
import togetherIllus from "../assets/illustrations/guide/emotional-awareness/together.svg";

export const EMOTIONAL_AWARENESS_COVER = {
  banner: "Know your emotions",
  illustration: coverIllus,
  illustrationAlt: "Heart and mind connected by awareness lines",
};

export const EMOTIONAL_AWARENESS_ACCENTS = ["amber", "electric", "fuchsia", "mint"];

export const EMOTIONAL_AWARENESS_SECTION_VISUALS = {
  introduction: {
    illustration: introductionIllus,
    illustrationAlt: "Figure pausing to notice inner emotional signals",
    banner: "Start here",
  },
  "emotional-awareness-explained": {
    illustration: explainedIllus,
    illustrationAlt: "Dashboard indicators representing emotional signals",
    banner: "The foundation",
  },
  "recognizing-emotional-patterns": {
    illustration: patternsIllus,
    illustrationAlt: "Repeating wave patterns across situations",
    banner: "See the pattern",
  },
  "naming-emotions": {
    illustration: namingIllus,
    illustrationAlt: "Emotion labels branching from a central feeling",
    banner: "Name it clearly",
  },
  "emotional-triggers": {
    illustration: triggersIllus,
    illustrationAlt: "Spark activating a deeper emotional response",
    banner: "Know your triggers",
  },
  "emotional-regulation": {
    illustration: regulationIllus,
    illustrationAlt: "Pause between feeling and chosen response",
    banner: "Respond wisely",
  },
  "understanding-shame": {
    illustration: shameIllus,
    illustrationAlt: "Figure emerging from shadow toward light",
    banner: "Heal shame",
  },
  "understanding-anger": {
    illustration: angerIllus,
    illustrationAlt: "Anger iceberg with deeper emotions beneath",
    banner: "Look beneath",
  },
  "building-emotional-resilience": {
    illustration: resilienceIllus,
    illustrationAlt: "Figure bending but not breaking under pressure",
    banner: "Build strength",
  },
  "bringing-it-together": {
    illustration: togetherIllus,
    illustrationAlt: "Pause and examine connecting awareness to action",
    banner: "Pause and examine",
  },
};

export function getEmotionalAwarenessSectionVisual(sectionId) {
  return EMOTIONAL_AWARENESS_SECTION_VISUALS[sectionId] || null;
}

export function getEmotionalAwarenessAccent(index) {
  return EMOTIONAL_AWARENESS_ACCENTS[index % EMOTIONAL_AWARENESS_ACCENTS.length];
}
